<template>
  <!-- v-bind:style="{ backgroundImage: 'url(' + bg + ')' }"-->
  <div class="text-center">
    <div style="height: 200px"></div>
    <v-row align="center" justify="center">
      <v-col>
        <v-card
          style="
            width: 382px;
            position: relative;
            left: 0;
            right: 0;
            margin: 0 auto;
          "
          class="pa-3 rounded-lg"
          elevation="13"
        >
          <img src="@/assets/img/logo-full-text.png" style="height: 100px" />

          <v-form v-model="valid">
            <v-card-text>
              <v-text-field
                v-model="form.email"
                label="อีเมล"
                placeholder="กรุณากรอกข้อมูล"
                dense
                outlined
                required
              ></v-text-field>
              <v-text-field
                type="password"
                v-model="form.password"
                label="รหัสผ่าน"
                dense
                outlined
                required
              ></v-text-field>
            </v-card-text>
            <div class="px-4">
              <v-btn depressed block color="primary" @click="onSubmit()"
                >เข้าสู่ระบบ</v-btn
              >

              <!-- 
              <div class="my-3">
                <v-btn text block color="primary" :to="`/forget_password`"
                  >ลืมรหัสผ่าน</v-btn
                >
              </div>
              -->
            </div>
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="text-center"></v-col>
      <v-col class="text-center"> </v-col>
      <v-col class="text-center"></v-col>
    </v-row>
  </div>
</template>

<script>
import Service from "@/services";

export default {
  data: () => ({
    valid: true,
    isLoading: false,
    form: {
      email: "",
      password: "",
    },
  }),
  created() {},
  methods: {
    onSubmit() {
      this.$store
        .dispatch("Auth/login", this.form)
        .then((res) => {
          this.$store.dispatch("Auth/setUser");
          this.isLoading = false;
          this.$router.push("/");
        })
        .catch((err) => {
          alert(err);
          this.isLoading = false;
        });
      return;
      Service.Auth.login(this.form)
        .then((res) => {
          this.$bus.$emit("message:show", {
            icon: "success",
            title: "เข้าสู่ระบบสำเร็จ",
            subtitle: "",
          });

          this.$store.dispatch("user/setToken", res.token);

          Service.Auth.me().then((res) => {
            this.$bus.$emit("message:hide", {});
            this.$store.dispatch("user/setInfo", res);
            this.$router.push({ path: "/?ref=login" });
          });
          this.$nuxt.$loading.finish();
        })
        .catch((e) => {
          console.log(e);
          this.$bus.$emit("message:show", {
            icon: "failed",
            title: "เข้าสู่ระบบไม่สำเร็จ",
            subtitle: "อีเมลหรือรหัสผ่านของคุณไม่ถูกต้อง",
          });
          this.$nuxt.$loading.finish();
        });
      //this.$router.push({ path: "/?ref=login" });

      //   Service.Auth.login(this.form)
      //     .then((res) => {
      //       if (res.data.access_token) {
      //         this.$store
      //           .dispatch("user/setToken", res.data.access_token)
      //           .then(() => {
      //             setTimeout(() => {
      //               Service.Auth.me().then((res) => {
      //                 this.$store.dispatch("user/setInfo", res.data);
      //                 this.$router.push({ path: "/?ref=login" });
      //                 this.$nuxt.$loading.finish();
      //               });
      //             }, 500);
      //           });
      //       } else {
      //         this.$nuxt.$loading.finish();
      //       }
      //     })
      //     .catch((e) => {
      //       //alert(JSON.stringify(e));
      //     });
      /*
            //this.$router.push({path: '/?ref=login'});=
            Service.Auth.login(this.form).then(res=>{
                console.log(res.data)
                if(res.data.access_token){
                    this.$store.dispatch("user/setToken", res.data.access_token);
                }
            }).catch(e=>{
                alert(JSON.stringify(e))
            })
            */
    },
  },
};
</script>
